import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useGlobalConfigContext } from '../global-config'
import { StaticImage } from '../image'
import {
  urlResolverGetInteractions,
  urlResolverGetMyTherapyApp,
  urlResolverGetOnlineArztService,
} from '../url-handling'

import { ErxHubArrowLink } from './ErxHubArrowLink'
import ImgServices from './images/ImgServices.png'

export const ErxHubServicesCard: FC = () => {
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()

  return (
    <div className="flex flex-1 flex-col overflow-hidden rounded-m">
      <div className="h-36 w-full bg-light-brand-high">
        <StaticImage
          alt={intl.formatMessage({ id: 'nfc.moreInfo.services.title' })}
          className="w-full"
          src={ImgServices}
        />
      </div>
      <div className="flex w-full grow gap-4 bg-light-brand-medium p-4 font-medium">
        <span className="text-m">
          <FormattedMessage id="nfc.moreInfo.services.title" />
        </span>

        <div className="flex w-full flex-col gap-2">
          <ErxHubArrowLink url={urlResolverGetInteractions(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.services.interactionCheck" />
          </ErxHubArrowLink>

          <ErxHubArrowLink url={urlResolverGetMyTherapyApp(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.services.therapyApp" />
          </ErxHubArrowLink>

          <ErxHubArrowLink url={urlResolverGetOnlineArztService(globalConfig)}>
            <FormattedMessage id="nfc.moreInfo.services.onlineDoctor" />
          </ErxHubArrowLink>
        </div>
      </div>
    </div>
  )
}
